import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui';

const Error403 = () => {
  const navigate = useNavigate();
  return (
    <div className="tw-flex tw-min-h-[70vh] tw-flex-col tw-items-center tw-justify-center tw-text-center">
      <div className="tw-mb-4 tw-text-[5rem] tw-font-extrabold tw-leading-none tw-text-heading">403</div>
      <h1 className="tw-text-xl tw-font-bold tw-text-heading">Access forbidden</h1>
      <p className="tw-mt-2 tw-max-w-sm tw-text-content-muted">
        You don't have permission to view this resource.
      </p>
      <Button className="tw-mt-6" icon="fa-house" onClick={() => navigate('/stream-dashboard')}>
        Back to Dashboard
      </Button>
    </div>
  );
};

export default Error403;
